// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".0c421b56a7c31ff2bf2352c611cec7990d60f8f0.chunk.js";
};